import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Button from '@mui/material/Button'
import { useRouter } from 'next/router'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import sx from './styles'

const EmptyState = ({
  text,
  title,
  btn,
  image,
}) => {
  const router = useRouter()
  const { formatMessage: f } = useIntl()

  return (
    <Grid
      container
      sx={sx.container}
    >
      <Grid>
        {image}
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        {
          title && (
            <Typography
              variant="h2"
              sx={sx.titleh2}
            >
              <FormattedMessage id={title} />
            </Typography>
          )
        }

        {
          text && (
            <Typography
              variant="h4"
              mt={2}
              sx={sx.titleh2}
            >
              <FormattedMessage id={text} />
            </Typography>
          )
        }

      </Grid>

      {
        btn && (
          <Grid
            size={{
              xs: 12,
              md: 6,
            }}
            mt={2}
          >
            <Button
              fullWidth
              sx={sx.mainButtom}
              variant={btn.variant}
              onClick={() => router.push(f({ id: btn.redirect }))}
              aria-label={f({ id: btn.cta })}
            >
              {f({ id: btn.cta })}
            </Button>
          </Grid>
        )
      }

    </Grid>
  )
}

export default EmptyState
